import React, { useEffect, useState } from "react";
import Search from "../Search/Search";

const Manage = () => {
  const [resources, setResources] = useState([]);
  const [toggle, setToggle] = useState(false);
  useEffect(() => {
    fetch("https://apichothaon1-hzrifat.b4a.run/all-resources")
      .then((res) => res.json())
      .then((data) => setResources(data));
  }, [toggle]);
  return (
    <div>
      <div className="container row">
        <div className="col-md-4 col-sm-6 col-12 ms-0 ps-0">
          <Search />
        </div>
        <div className="my-5 col-md-8 col-sm-6 col-12">
          <div className="row">
            {resources?.length
              ? resources?.map((r) => {
                  const changeData = (e) => {
                    fetch(`https://apichothaon1-hzrifat.b4a.run/resource`, {
                      method: "PUT",
                      headers: {
                        "Content-Type": "application/json",
                      },
                      body: JSON.stringify(r),
                    })
                      .then((res) => res.json())
                      .then((data) => {
                        if (data?._id) {
                          setToggle(!toggle);
                        }
                      });
                  };
                  return (
                    <div className="col-4 col-md-6 col-12">
                      <div
                        style={{ background: "rgba(255, 255, 255, 0.5)" }}
                        className="rounded shadow-lg my-2 mx-0 p-4"
                      >
                        <h4>
                          {r?.subjectName ? (
                            r?.subjectName
                          ) : (
                            <span>Subject Not Specified</span>
                          )}
                        </h4>
                        <p>
                          {r?.subject} - {r?.series} Series
                        </p>
                        {r?.uploader ? (
                          <p className="text-secondary">
                            <small>Shared by {r?.uploader}</small>
                          </p>
                        ) : (
                          <p className="text-secondary">
                            <small>Unknown Sharer</small>
                          </p>
                        )}
                        <p>
                          <span style={{ fontWeight: "500" }}>Title:</span>{" "}
                          {r?.title}
                        </p>
                        {r?.details ? (
                          <p>
                            <span style={{ fontWeight: "500" }}>Details:</span>{" "}
                            {r?.details}
                          </p>
                        ) : null}
                        <a target="_blank" href={r?.link}>
                          <button className="btn-custom border-0 rounded px-2 py-1">
                            Study
                          </button>
                        </a>
                        {r?.status ? (
                          <button
                            style={{ border: "1px solid rgba(0, 0, 0, 0.5)" }}
                            className="ms-2"
                            onClick={changeData}
                          >
                            <span className="text-success">Verified</span>
                          </button>
                        ) : (
                          <button
                            style={{ border: "1px solid rgba(0, 0, 0, 0.5)" }}
                            className="ms-2"
                            onClick={changeData}
                          >
                            <span className="text-danger">Pending</span>
                          </button>
                        )}
                      </div>
                    </div>
                  );
                })
              : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Manage;
